import React from 'react';
import type { Component } from '../../types/builder';
import { PictureRenderer } from './Renderers/PictureRenderer';
import { PictureSliderRenderer } from './Renderers/PictureSliderRenderer';
import { FormRenderer } from './Renderers/FormRenderer';
import { VideoRenderer } from './Renderers/VideoRenderer';
import { OnlineUsersRenderer } from './Renderers/OnlineUsersRenderer';
import { RecentWithdrawalsRenderer } from './Renderers/RecentWithdrawalsRenderer';
import { StatsBoxRenderer } from './Renderers/StatsBoxRenderer';
import { JackpotRenderer } from './Renderers/JackpotRenderer';
import { CountdownTimerRenderer } from './Renderers/CountdownTimerRenderer';
import { BannerSlideRenderer } from './Renderers/BannerSlideRenderer';
import { GameRTPRenderer } from './Renderers/GameRTPRenderer';
import { LinkRenderer } from './Renderers/LinkRenderer';
import { ProfileRenderer } from './Renderers/ProfileRenderer';
import { NameRenderer } from './Renderers/NameRenderer';
import { BioRenderer } from './Renderers/BioRenderer';
import { BrandLogoRenderer } from './Renderers/BrandLogoRenderer';
import { PartnerLogosRenderer } from './Renderers/PartnerLogosRenderer';
import { LeaderboardRenderer } from './Renderers/LeaderboardRenderer';
import { FAQRenderer } from './Renderers/FAQRenderer';
import { SocialIconsRenderer } from './Renderers/SocialIconsRenderer';
import { TestimonialRenderer } from './Renderers/TestimonialRenderer';
import { GoogleReviewsRenderer } from './Renderers/GoogleReviewsRenderer';
import { SurveyRenderer } from './Renderers/SurveyRenderer';
import { MusicPlayerRenderer } from './Renderers/MusicPlayerRenderer';
import { SpinWheelRenderer } from './Renderers/SpinWheelRenderer';

interface ComponentRendererProps {
  component: Component;
}

export const ComponentRenderer: React.FC<ComponentRendererProps> = ({ component }) => {
  switch (component.type) {
    case 'picture':
      return <PictureRenderer component={component} />;
    case 'pictureSlider':
      return <PictureSliderRenderer component={component} />;
    case 'form':
      return <FormRenderer component={component} />;
    case 'video':
      return <VideoRenderer component={component} />;
    case 'onlineUsers':
      return <OnlineUsersRenderer component={component} />;
    case 'recentWithdrawals':
      return <RecentWithdrawalsRenderer component={component} />;
    case 'statsBox':
      return <StatsBoxRenderer component={component} />;
    case 'jackpot':
      return <JackpotRenderer component={component} />;
    case 'countdownTimer':
      return <CountdownTimerRenderer component={component} />;
    case 'bannerSlide':
      return <BannerSlideRenderer component={component} />;
    case 'gameRTP':
      return <GameRTPRenderer component={component} />;
    case 'link':
      return <LinkRenderer component={component} />;
    case 'profile':
      return <ProfileRenderer component={component} />;
    case 'name':
      return <NameRenderer component={component} />;
    case 'bio':
      return <BioRenderer component={component} />;
    case 'brandLogo':
      return <BrandLogoRenderer component={component} />;
    case 'partnerLogos':
      return <PartnerLogosRenderer component={component} />;
    case 'leaderboard':
      return <LeaderboardRenderer component={component} />;
    case 'faq':
      return <FAQRenderer component={component} />;
    case 'socialIcons':
      return <SocialIconsRenderer component={component} />;
    case 'testimonial':
      return <TestimonialRenderer component={component} />;
    case 'googleReviews':
      return <GoogleReviewsRenderer component={component} />;
    case 'survey':
      return <SurveyRenderer component={component} />;
    case 'musicPlayer':
      return <MusicPlayerRenderer component={component} />;
    case 'spinWheel':
      return <SpinWheelRenderer component={component} />;
    default:
      return null;
  }
};
